import React from 'react';
import { Grid, Box } from '@mui/material';

// Magazine cover images
const MAGAZINE_COVERS = [
  {
    url: "https://dp9h3awfnhccl.cloudfront.net/public_folder/issue_current.jpeg",
    alt: "YoungPresso Issue 1"
  },
  {
    url: "https://dp9h3awfnhccl.cloudfront.net/public_folder/issue2c.jpg",
    alt: "YoungPresso Issue 2"
  },
  {
    url: "https://dp9h3awfnhccl.cloudfront.net/public_folder/issue3c.jpg",
    alt: "YoungPresso Issue 3"
  },
  {
    url: "https://dp9h3awfnhccl.cloudfront.net/public_folder/issue4c.jpg",
    alt: "YoungPresso Issue 4"
  }
];

const MagazineCoverGrid = ({ onClick }) => {
  return (
    <Grid container spacing={{ xs: 1.5, sm: 2 }}>
      {MAGAZINE_COVERS.map((cover, index) => (
        <Grid item xs={6} key={index}>
          <Box
            onClick={onClick}
            sx={{
              position: 'relative',
              width: '100%',
              height: { xs: '260px', sm: '340px', md: '400px', lg: '450px' },
              borderRadius: { xs: '12px', md: '20px' },
              overflow: 'hidden',
              boxShadow: { xs: '0 4px 12px rgba(255,107,53,0.25)', md: '0 10px 30px rgba(255,107,53,0.3)' },
              transition: 'all 0.4s ease',
              cursor: onClick ? 'pointer' : 'default',
              border: '2px solid rgba(255,107,53,0.2)',
              background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
              backdropFilter: 'blur(10px)',
              '&:hover': {
                transform: { xs: 'translateY(-4px)', md: 'translateY(-12px) scale(1.02)' },
                boxShadow: { xs: '0 8px 20px rgba(255,107,53,0.35)', md: '0 20px 50px rgba(255,107,53,0.4)' },
                border: '2px solid rgba(255,107,53,0.5)'
              },
              animation: { xs: 'none', md: `bounce${index + 1} 4s ease-in-out infinite` },
              animationDelay: `${index * 0.5}s`
            }}
          >
            <img
              src={cover.url}
              alt={cover.alt}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
                transition: 'transform 0.3s ease'
              }}
              onError={(e) => {
                e.target.style.backgroundColor = '#f5f5f5';
                e.target.alt = 'Magazine Cover';
              }}
            />
          </Box>
        </Grid>
      ))}
      
      {/* Add keyframes for staggered bounce animations */}
      <style jsx>{`
        @keyframes bounce1 {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes bounce2 {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-12px); }
        }
        @keyframes bounce3 {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        @keyframes bounce4 {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
        }
      `}</style>
    </Grid>
  );
};

export default MagazineCoverGrid;
